import {call, put, select} from "redux-saga/effects";

import {LOADER_ID_SHOP} from "./constants";
import {_sharedActionsSystem} from "../system/actions";
import {_sharedActionsShop} from "./actions";
import {getPackagesRequest, getShopBooksRequest} from "../../api/shopApi";
import {selectorShopIsPackagesFetched} from "./selectors";
import {selectorLoaderById} from "../system/selectors";

export function* _sharedWorkerFetchShopBooks(action) {
  const isPackagesFetched = yield select(selectorShopIsPackagesFetched);
  if (isPackagesFetched) {
    return;
  }
  const isLoading = yield select((s) => selectorLoaderById(s, LOADER_ID_SHOP));
  if (isLoading) {
    return;
  }

  const booksToFetch = new Set(action.data);

  yield put(_sharedActionsSystem.loading(LOADER_ID_SHOP));
  yield put(_sharedActionsShop.fetchPackagesPending());
  const packagesData = yield call(getPackagesRequest);
  const packages = packagesData?.packages || [];
  yield put(_sharedActionsShop.fetchPackagesSuccess(packages));
  packages.forEach((shopPackage) => {
    shopPackage.items.forEach((shopBook) => {
      booksToFetch.add(shopBook.book_id);
    });
  });

  if (booksToFetch.size) {
    const booksToFetchArray = [...booksToFetch];
    yield put(_sharedActionsShop.fetchShopBooksPending(booksToFetchArray));
    const shopData = yield call(getShopBooksRequest, booksToFetchArray);
    yield put(_sharedActionsShop.fetchShopBooksSuccess(shopData?.books, booksToFetchArray));
  }

  yield put(_sharedActionsSystem.loading(LOADER_ID_SHOP, true));
}
